import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/container/container.js");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleGrid"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/simple-grid/simple-grid.js");
